import React from "react";

export const PartnersSection = () => {
  const logos = [
    {
      name: "Cloudflare", // Web Security & Performance
      src: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Cloudflare_logo.svg",
    },
    {
      name: "DigitalOcean", // Cloud Infrastructure
      src: "https://upload.wikimedia.org/wikipedia/commons/f/ff/DigitalOcean_logo.svg",
    },
    {
      name: "Twilio", // Communication APIs
      src: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Twilio_logo.svg",
    },
    {
      name: "Asana", // Project Management
      src: "https://upload.wikimedia.org/wikipedia/commons/3/3b/Asana_logo.svg",
    },
    {
      name: "Fastly", // Edge Cloud Platform
      src: "https://upload.wikimedia.org/wikipedia/commons/a/a3/Fastly_logo.svg",
    },
    {
      name: "Zendesk", // Customer Service Software
      src: "https://upload.wikimedia.org/wikipedia/commons/9/9e/Zendesk_logo.svg",
    },
  ];

  return (
    <div className="py-16 bg-gray-50 border-t border-gray-100">
      <div className="container mx-auto px-4">
        <p className="text-center text-sm font-bold text-gray-400 uppercase tracking-widest mb-8">
          Powered by Industry Leading Tech
        </p>

        {/* Animated Logo Carousel */}
        <div className="relative overflow-hidden w-full mask-linear-gradient">
          <div
            className="flex w-max"
            style={{
              animation: "scroll 30s linear infinite",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.animationPlayState = "paused")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.animationPlayState = "running")
            }
          >
            {/* 1. First set of logos */}
            <div className="flex space-x-12 md:space-x-24 px-6 md:px-12">
              {logos.map((logo, index) => (
                <div
                  key={`logo-1-${index}`}
                  className="flex items-center justify-center h-16 w-32 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-pointer"
                >
                  <img
                    src={logo.src}
                    alt={logo.name}
                    className="max-h-8 md:max-h-10 w-auto object-contain"
                  />
                </div>
              ))}
            </div>

            {/* 2. Duplicate set for seamless loop */}
            <div className="flex space-x-12 md:space-x-24 px-6 md:px-12">
              {logos.map((logo, index) => (
                <div
                  key={`logo-2-${index}`}
                  className="flex items-center justify-center h-16 w-32 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500 cursor-pointer"
                >
                  <img
                    src={logo.src}
                    alt={logo.name}
                    className="max-h-8 md:max-h-10 w-auto object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .mask-linear-gradient {
          mask-image: linear-gradient(
            to right,
            transparent,
            black 10%,
            black 90%,
            transparent
          );
          -webkit-mask-image: linear-gradient(
            to right,
            transparent,
            black 10%,
            black 90%,
            transparent
          );
        }
      `}</style>
    </div>
  );
};
